// extracted by mini-css-extract-plugin
export default {"landing__wrapper":"Landing_landing__wrapper__8zAa6","landing__text":"Landing_landing__text__W9OH4","landing__img":"Landing_landing__img__K3YRI"};